import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { I18nService } from '../../../shared/services/i18n.service';

@Component({ template: '' })
export class LanguageRedirectComponent implements OnInit {
  private i18n = inject(I18nService);
  private route = inject(ActivatedRoute);

  ngOnInit() {
    const params = this.route.snapshot.queryParamMap;
    const target = params.get('target');

    if (target) {
      // Collect all query params except 'target' to forward them
      const forwardParams: Record<string, string> = {};
      for (const key of params.keys) {
        if (key !== 'target') {
          forwardParams[key] = params.get(key)!;
        }
      }
      this.i18n.redirectToBrowserLanguage(target, forwardParams);
    } else {
      this.i18n.redirectToBrowserLanguage();
    }
  }
}
